module.exports = __webpack_public_path__ + "static/media/user-icon-green-2.3a44ffac.svg";